import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "booking-departure" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DepartureHeader = _resolveComponent("DepartureHeader")!
  const _component_BookingDepartureDate = _resolveComponent("BookingDepartureDate")!
  const _component_BookingDepartureList = _resolveComponent("BookingDepartureList")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DepartureHeader, {
      fromDestination: _ctx.fromDestination,
      toDestination: _ctx.toDestination,
      direction: _ctx.direction
    }, null, 8, ["fromDestination", "toDestination", "direction"]),
    _createVNode(_component_BaseSection, {
      errors: _ctx.v$.departure.$errors
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BookingDepartureDate, { direction: _ctx.direction }, null, 8, ["direction"]),
        _createVNode(_component_BookingDepartureList, {
          loading: _ctx.loading,
          departures: _ctx.departures,
          direction: _ctx.direction,
          disabled: _ctx.disableList
        }, null, 8, ["loading", "departures", "direction", "disabled"])
      ]),
      _: 1
    }, 8, ["errors"])
  ]))
}